module.exports = __webpack_public_path__ + "img/lct_icon1.0b88d25a.svg";